<template>
  <b-row>
    <!-- Is Active -->
    <b-col cols="12" md="3" class="mb-md-0 mb-2">
      <label>Status</label>
      <v-select
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :value="isActiveFilter"
        :options="isActiveOptions"
        class="w-100"
        :reduce="(val) => val.value"
        @input="handleFilterChange"
        placeholder="Select Status"
      />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue';
import vSelect from 'vue-select';

export default {
  name: 'HSCodeListFilters',
  components: {
    BRow,
    BCol,
    vSelect,
  },
  props: {
    isActiveFilter: {
      type: [Boolean, null],
      default: null,
    },
  },
  data() {
    return {
      isActiveOptions: [
        { value: null, label: 'All' },
        { value: true, label: 'Active' },
        { value: false, label: 'Inactive' },
      ],
    };
  },
  methods: {
    handleFilterChange(val) {
      console.log('=== HSCodeListFilters handleFilterChange:', { val, type: typeof val });
      this.$emit('update:is-active-filter', val);
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
